(function () {
    angular.module('feedResource', ['ngResource'])
        .factory('feedResource', feedResource);

    feedResource.$inject = ['$resource'];
    function feedResource($resource) {
        return {
            list: $resource('/api/feed/:id', { id: '@id' })
        };
    }
})();